import React from 'react';
import { string } from 'prop-types';
import cn from 'classnames';

import styles from './styles.module.scss';

function SimpleSpinner({ className, containerClassName, analyticsId }) {
  return (
    <div className={cn('item-1 row middle center', containerClassName)}>
      <div id={analyticsId} className={cn(styles.spinner, className)} />
    </div>
  );
}

SimpleSpinner.propTypes = {
  analyticsId: string,
  className: string,
  containerClassName: string
};

export default SimpleSpinner;
